<div class="p-b-24 overflow-hidden" style="height: 90px;">
  <div>
    <div class="row">
      <div class="col-lg-7 col-sm-6">
        <h4 class="page-title m-0 f-s-18 f-w-500">


           @if(currentRoute[1] && currentRoute[1].url=='/section/home/privacyPolicy'){

            <p class="blue" style="margin: 0px">Privacy Policy</p>
              <div class="d-flex align-items-center overflow-hidden justify-content-start list-style-none">
               
              </div>
          }

          @if(currentRoute[0].url=='/section/educationalGallery'){

            <p class="blue" style="margin: 0px">{{"sidebar.educationalGallery" | translate}}</p>
              <div class="d-flex align-items-center overflow-hidden justify-content-start list-style-none">
                <ul class="breadcrumb list-style-none d-flex p-l-0">
                  <li class="breadcrumb-item subtitle">
                      {{"educationalContents.educationalGallerySubtext" | translate}}
                  </li>
                </ul>
              </div>
          }

          @else if(currentRoute[0].url=='/section/analysis'){
             <p class="blue" style="margin: 0px">{{"sidebar.dataAnalysis" | translate}}</p>
              <div class="d-flex align-items-center overflow-hidden justify-content-start list-style-none">
                <ul class="breadcrumb list-style-none d-flex p-l-0">
                  <li class="breadcrumb-item subtitle">
                      {{"dataAnalysis.dataAnalysisSubtext" | translate}}
                  </li>
                </ul>
              </div>
            
            
          }

          @else if(role!='admin' && (currentRoute[0].url.indexOf('/section/intervention')!=-1)){
            <p class="blue" style="margin: 0px">{{"intervention.sunriseIntervention" | translate}}</p>
              <div class="d-flex align-items-center overflow-hidden justify-content-start list-style-none">
                <ul class="breadcrumb list-style-none d-flex p-l-0">
                  <li class="breadcrumb-item subtitle">
                      {{"intervention.adjustInterventionSubtext" | translate}}
                  </li>
                </ul>
              </div>
            
          }

          @else if(role!='admin' && currentRoute[0].url=='/section/students'){

            <p class="blue" style="margin: 0px">{{"sidebar.students" | translate}}</p>
            <div class="d-flex align-items-center overflow-hidden justify-content-start list-style-none">
                <ul class="breadcrumb list-style-none d-flex p-l-0">
                  <li class="breadcrumb-item subtitle">
                     {{"students.studentsSubtext" | translate}}
                  </li>
                </ul>
              </div>
            
          }


          @else if(role=='admin' && currentRoute.length == 1){

             <p class="blue" style="margin: 0px">{{'countries.'+pilot | translate}} · {{ "sidebar.sunrisePilot" | translate}}</p>

          }@else if((role=='admin' && currentRoute[0].url.indexOf('home') != -1 && currentRoute.length == 2)|| (role!='admin' && currentRoute[0].url.indexOf('home') != -1)) {
             
             <p class="blue" style="margin: 0px" *ngIf="!(currentRoute[1] && currentRoute[1].url=='/section/home/privacyPolicy')">{{schoolName}}</p>
            
          }
        </h4>
        <div *ngIf="currentRoute[0].url.indexOf('home')!=-1"
          class="d-flex align-items-center overflow-hidden justify-content-start list-style-none"
        >
          <ul class="breadcrumb list-style-none d-flex p-l-0 subtitle">
            @for (url of pageInfo?.['urls']; track url.url;let index = $index,last
            = $last ) { 
              @if(currentRoute[0].url.indexOf('home')!=-1){
              @if(!last){
            <li class="breadcrumb-item" [routerLink]="url.url">
              <a [routerLink]="url.url" style="font-size: 13px; color: #768B9E;">{{ 'sidebar.'+url.title | translate }}</a>
              <span class="breadcrumb-item separator">></span>
            </li>
            }@else {
              
            <li class="breadcrumb-item"> {{ 'sidebar.'+url.title | translate }}</li>
            } } }
          

            <span class="breadcrumb-item separator2"></span>
            <span *ngIf="params!='{}' && paramKey && paramKey.length!=0" style="color: #768B9E"> {{params[paramKey]}}</span>
        
          </ul>
        </div>
      </div>
      <div *ngIf="!(currentRoute[1] && currentRoute[1].url.indexOf('privacyPolicy')!=-1)"
        class="col-lg-5 col-sm-6 text-right position-relative align-items-center justify-content-end gap-20 d-none d-sm-flex"
      >
        <div class="d-flex align-items-center justify-content-end" style="width: 100%; height: 100%;">
          <div *ngFor="let element of indicatorsElements.keys; let i=index" style="height: 100%; padding-bottom: 14px;">
            <div class="d-flex flex-column align-items-center" style="height: 100%; justify-content: space-between;" [ngStyle]="{'padding-right': i!=(indicatorsElements.keys.length-1) ? '10px' : '0px' }">
              <p class="subtitle4" style="text-align: center; line-height: 17px;">
                {{'home.'+element | translate}}
              </p>
              <p class="blueIndicator">{{indicators[element]}}</p>
            </div>

          </div>
      </div>
    </div>
  </div>
</div>
